import axios from 'axios';
import { getAxios } from '@parchment/oauth2-axios';
import { checkHttpStatus } from '../common/utils/ApiUtils';
import { AUTHENTICATE_USER_ERROR, AUTHENTICATE_USER_SUCCESS,
    CREATE_NEW_LEARNER_ERROR, CREATE_NEW_LEARNER_SUCCESS,
    CREATE_NEW_TPO_USER_ERROR, CREATE_NEW_TPO_USER_SUCCESS, DEAUTHENTICATE_USER,
    PARCHMENT_IDENTITY_PROVIDER_KEY, PROCESS_VERIFICATION_CODE_ERROR,
    PROCESS_VERIFICATION_CODE_SUCCESS, SEND_VERIFICATION_EMAIL_ERROR,
    SEND_VERIFICATION_EMAIL_SUCCESS } from './index';
import { ORDER_TYPE } from '../common/constants/OrderType';

const PARCHMENT_IDENTITY_SERVICE_BASE_URL = window.config.service.parchmentIdentityProviderUrl;

export async function addNewLearner(params) {
    try {
        const response = await axios.post('/u/registration/learner', params);
        checkHttpStatus(response);
        return {
            type: CREATE_NEW_LEARNER_SUCCESS,
            payload: response.data
        };
    } catch (error) {
        return {
            type: CREATE_NEW_LEARNER_ERROR,
            payload: error
        };
    }
}

export async function addNewUser(params) {
    const url = `${PARCHMENT_IDENTITY_SERVICE_BASE_URL}/individual`;
    try {
        const response = await getAxios(PARCHMENT_IDENTITY_PROVIDER_KEY).post(url, params);
        checkHttpStatus(response);
        return {
            type: CREATE_NEW_TPO_USER_SUCCESS,
            payload: response.data
        };
    } catch (error) {
        return {
            type: CREATE_NEW_TPO_USER_ERROR,
            payload: error
        };
    }
}

export async function verifyUser(params) {
    try {
        const response = await axios.post('/u/registration/institution/verify', params);
        checkHttpStatus(response);
        return {
            type: SEND_VERIFICATION_EMAIL_SUCCESS,
            payload: response.data
        };
    } catch (error) {
        return {
            type: SEND_VERIFICATION_EMAIL_ERROR,
            payload: error
        };
    }
}

export async function processConfirmation(params) {
    try {
        const response = await axios.post('/u/registration/institution/process/confirm', params);
        checkHttpStatus(response);
        return {
            type: PROCESS_VERIFICATION_CODE_SUCCESS,
            payload: response.data
        };
    } catch (error) {
        return {
            type: PROCESS_VERIFICATION_CODE_ERROR,
            payload: error
        };
    }
}

export async function authenticateNewUser(username, password, senderId, orderType) {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    formData.append('csrfToken', window.csrfToken);
    if (typeof senderId !== 'undefined') {
        formData.append('senderId', senderId);
    }
    if (orderType && orderType === ORDER_TYPE.LEARNER) {
        formData.append('learner', 'true');
    }

    try {
        const response = await axios.post('/u/auth/api/login', formData,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        checkHttpStatus(response);
        return {
            type: AUTHENTICATE_USER_SUCCESS,
            payload: response.data
        };
    } catch (error) {
        return {
            type: AUTHENTICATE_USER_ERROR,
            payload: error
        }
    }
}

export async function logoutNewUser() {
    const response = await axios.get('/u/auth/logout', {headers: {'X-Requested-With': 'XMLHttpRequest'}});
    return {
        type: DEAUTHENTICATE_USER,
        payload: response
    };
}
